export const LOCALE_SUGGESTION_SHOWN = 'LOCALE_SUGGESTION_SHOWN';
